import request from '@/utils/request'

/**
 * 供应链 - 我的应用
 */
export function fetchMyAppList() {
    return request({
        url: '/api/myApp/cateBySupplyChain',
        method: 'get'
    })
}


/**
 * 供应链 - 套餐列表
 */
export function fetchSupplyChainPlanList() {
    return request({
        url: '/api/app/planBySupplyChain',
        method: 'get'
    })
}

/**
 * 供应链 - 计算价格
 */
export function calcBySupplyChain(params) {
    return request({
        url: '/api/plan/calcBySupplyChain',
        method: 'post',
        data: params
    })
}

/**
 * 供应链 - 创建应用
 */
export function createSupplyChain(params) {
    return request({
        url: '/api/app/createBySupplyChain',
        method: 'post',
        data: params
    })
}

/**
 * 供应链 - 初始化数据库
 */
export function initDatabase(params) {
    return request({
        url: '/api/SupplyChainDb/initDatabase',
        method: 'post',
        data: params
    })
}

/**
 * 供应链 - 初始化站长域名
 */
export function initDomain(params) {
    return request({
        url: '/api/SupplyChainDomain/initDomain',
        method: 'post',
        data: params
    })
}

/**
 * 供应链 - 编辑应用名称
 */
export function editBySupplyChain(params) {
    return request({
        url: '/api/app/editBySupplyChain',
        method: 'post',
        data: params
    })
}